"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = exports.extension = void 0;
exports.extension = '.json';
function filterFields(key, value) {
    if (key === 'parent')
        return;
    if (value === undefined)
        return;
    if (['caller', 'callee'].includes(key))
        return value.id;
    return value;
}
function format(diagram) {
    return JSON.stringify(diagram, filterFields, 2);
}
exports.format = format;
